import { PermissionEnum } from '@creditsights/api-ui-web';
import { Divider } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React from 'react';

import { Link } from 'react-router-dom';
import useFetchUserPermissions from '../../../../hooks/permissions/useFetchUserPermissions';
import { RecommendationDto } from '../../../../services/dtos/issuer/recommendation.dto';
import { getIssuerRoute } from '../../../../utils/navigationUtils';
import { WeightingType } from '../../../WeightIcon/WeightIcon';
import RecommendationDate from '../../common/RecommendationDate';
import { RecommendationType } from '../../common/RecommendationDate/RecommendationDate';
import styles from './CSViewWidgetContent.module.scss';

const cx = classNames.bind(styles);

interface RecommendationReviewedProps {
  issuerTag: string;
  data: RecommendationDto | undefined;
  showLinkToCompany: boolean;
  truncateContent: boolean;
}

const CSViewWidgetContent = ({
  data,
  issuerTag,
  showLinkToCompany,
  truncateContent,
}: RecommendationReviewedProps): React.ReactElement => {
  const { data: userPermissions } = useFetchUserPermissions();

  if (!data) {
    return <p>CS View not found</p>;
  }

  return (
    <div className={classNames(cx('body'), 'to-translate')} data-testid="cs-view-widget-content">
      {data.comment && (
        <span className={cx('comment', { 'truncate-content': truncateContent })} data-testid="comment-content">
          {data.comment}
        </span>
      )}
      <div className={cx('additional-info')}>
        {data.weighting !== WeightingType.NoRecommendation ? (
          <>
            <RecommendationDate
              type={RecommendationType.REVIEW}
              date={data.publishDate}
              articleId={data.publishedInArticleId}
            />
            <Divider vertical className={cx('print-divider')} />
            <RecommendationDate
              type={RecommendationType.CHANGE}
              date={data.changedDate}
              articleId={data.changeMadeInArticleId}
            />
          </>
        ) : null}
        {userPermissions!.permissions.includes(PermissionEnum.STAFF) && (
          <>
            <Divider vertical className={cx('print-divider')} />
            <RecommendationDate type={RecommendationType.COMMENT_CHANGE} date={data.commentLastChangedDate} />
          </>
        )}
        {showLinkToCompany && (
          <Link to={getIssuerRoute(issuerTag)} className={cx('company-link')} data-testid="company-link">
            View Company
          </Link>
        )}
      </div>
    </div>
  );
};

export default CSViewWidgetContent;
